import proj4 from 'proj4';
import { transform } from 'ol/proj';
import { getDistance } from 'ol/sphere';
import {proyeccion4326, proyeccion3857, proyeccion25829, proyeccion25830} from './configuracion';

const scaleDiv = document.getElementById('escala'),
coordinatesDiv = document.getElementById('coordenadas');

export function mousePosicion(e) {
    const c = e.coordinate;
    const proyeccion = document.getElementById('srid');
    switch (proyeccion.value) {
      case '25829':
        const coordenadas1 = proj4(proyeccion3857, proyeccion25829, [c[0], c[1]]);
        const [x1, y1]= coordenadas1.map(c => c.toFixed(2));
        coordinatesDiv.innerHTML = `<strong>| Posición:</strong> X= ${x1}, Y= ${y1}`;
        break;
      case '25830':
        const coordenadas2 = proj4(proyeccion3857, proyeccion25830, [c[0], c[1]]);
        const [x2, y2]= coordenadas2.map(c => c.toFixed(2));
        coordinatesDiv.innerHTML = `<strong>| Posición:</strong> X= ${x2}, Y= ${y2}`;
        break;
      case '4326':
        const coordenadas3 = proj4(proyeccion3857, proyeccion4326, [c[0], c[1]]);
        const [x3, y3]= coordenadas3.map(c => c.toFixed(2));
        coordinatesDiv.innerHTML = `<strong>| Posición:</strong>&nbsp;Longitud= ${x3},&nbsp;Latitud= ${y3}`;
        break;
    }
}

export function actualizarEscala() {
  let centerOfMap = global.mapa.getSize()[1] / 2;
  let coord1 = global.mapa.getCoordinateFromPixel([0, centerOfMap]);
  let coord2 = global.mapa.getCoordinateFromPixel([100, centerOfMap]);

  if (coord1 && coord2) {
      let coord1LatLon = transform(coord1, proyeccion3857, proyeccion4326);
      let coord2LatLon = transform(coord2, proyeccion3857, proyeccion4326);

      let realWorldMetersPer100Pixels = getDistance(coord1LatLon, coord2LatLon);
      let screenMetersPer100Pixels = pixelToMm(100) / 1000;

      let scaleFactor = realWorldMetersPer100Pixels / screenMetersPer100Pixels;
      let escala = scaleFactor.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      scaleDiv.innerHTML = `<strong>| Escala:&nbsp;</strong>&nbsp;1:&nbsp;${escala}`;
  }
}

function pixelToMm(px) {
  const mmPerInch = 25.4;
  const dpi = 96;
  return (px / dpi) * mmPerInch;
}